// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-withdrawal .custom-nav-block .van-bar .van-nav-bar__content .van-nav-bar__right{padding:0!important}.container-withdrawal .custom-nav-block .van-bar .van-nav-bar__content .van-nav-bar__right .tit-right{display:inline-flex;align-items:center;height:100%;padding:0 16px;margin-left:20px}", ""]);
// Exports
module.exports = exports;
